import { NgModule } from '@angular/core';
import { AsmComponentsModule } from '@spartacus/asm/components';
import { AsmOccModule } from '@spartacus/asm/occ';
import { CheckoutComponentsModule } from '@spartacus/checkout/base/components';
import { CheckoutOccModule } from '@spartacus/checkout/base/occ';
import { UserAccountModule } from '@spartacus/user/account';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideConfig,
  provideFeatureToggles,
  UserModule,
  UserOccModule,
} from '@spartacus/core';
import { ProductVariantsModule } from '@spartacus/product/variants';
import { PersonalizationModule } from '@spartacus/tracking/personalization';
import { SmartEditModule } from '@spartacus/smartedit';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  JsonLdBuilderModule,
  LinkModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
  UserComponentModule,
} from '@spartacus/storefront';
import {
  AddressBookModule,
  CloseAccountModule,
  ForgotPasswordModule,
  ResetPasswordModule,
  UpdateEmailModule,
  UpdatePasswordModule,
  UpdateProfileModule,
} from '@spartacus/user/profile/components';
import {
  OrderCancellationModule,
  OrderComponentsModule,
  OrderConfirmationModule,
  OrderDetailsModule,
} from '@spartacus/order/components';
import { OrderCoreModule } from '@spartacus/order/core';
import { OrderOccModule } from '@spartacus/order/occ';
import { CheckoutCoreModule } from '@spartacus/checkout/base/core';
import { CartBaseCoreModule } from '@spartacus/cart/base/core';
import { CartBaseOccModule } from '@spartacus/cart/base/occ';
import { OrderModule } from '@spartacus/order';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { UserFeatureModule } from './features/user/user-feature.module';
import { TagManagementFeatureModule } from './tag-management-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { UserProfileModule } from '@spartacus/user/profile';
import { WishListModule } from '@spartacus/cart/wish-list';
import { CartPageEventModule } from '@spartacus/cart/base/core';
import {
  ReplenishmentOrderDetailsModule,
  ReplenishmentOrderHistoryModule,
  OrderHistoryModule,
  ReturnRequestDetailModule,
  ReturnRequestListModule,
  OrderReturnModule,
} from '@spartacus/order/components';

@NgModule({
  imports: [
    // Auth Core
    AuthModule.forRoot(),

    // Basic Cms Components
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,

    // User Core
    UserAccountModule,
    UserOccModule,
    UserProfileModule,
    UserModule,
    UserOccModule,
    // User UI
    UserComponentModule,
    AddressBookModule,
    UpdateEmailModule,
    UpdatePasswordModule,
    UpdateProfileModule,
    CloseAccountModule,
    ForgotPasswordModule,
    ResetPasswordModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,

    // Anonymous Consents Core
    AnonymousConsentsModule.forRoot(),
    // Anonymous Consents UI
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,

    // Product Core
    ProductModule.forRoot(),
    ProductOccModule,

    // Product UI
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductVariantsModule,
    ProductIntroModule,

    // Cart Core
    CartBaseCoreModule,
    CartBaseOccModule,
    // Cart UI
    WishListModule,

    // Checkout Core
    CheckoutCoreModule,
    CheckoutOccModule,
    CostCenterOccModule,
    CheckoutFeatureModule,
    // Checkout UI
    CheckoutComponentsModule,
    OrderConfirmationModule,

    // Order
    OrderHistoryModule,
    OrderDetailsModule,
    OrderCancellationModule,
    OrderReturnModule,
    ReturnRequestListModule,
    ReturnRequestDetailModule,
    ReplenishmentOrderHistoryModule,
    ReplenishmentOrderDetailsModule,
    OrderCoreModule,
    OrderOccModule,
    OrderComponentsModule,
    OrderModule,

    // SmartEdit
    SmartEditModule,
    // Personalization
    PersonalizationModule,

    // Asm Core
    AsmOccModule,
    // Asm UI
    AsmComponentsModule,

    // Page Eventss
    CartPageEventModule,
    ProductPageEventModule,
    NavigationEventModule,

    /************************* Opt-in features *************************/
    ExternalRoutesModule.forRoot(), // to opt-in explicitly, added by default schematics
    JsonLdBuilderModule,
    SmartEditFeatureModule,
    UserFeatureModule,
    AsmFeatureModule,
    TagManagementFeatureModule,

    /************************* External features *************************/
  ],

  providers: [
    provideFeatureToggles({
      authorizationCodeFlowByDefault: false,
      incrementProcessesCountForMergeCart: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      cdsLoginEventsToken: true,
      enableQuotePurchaseOrderNumber: true,
      navigationMenuCloseOnSameLinkClick: true,
      enableReturnOrderReturnableQuantityConsigmentFallback: true,
      enablePasswordExpiredErrorTranslation: true,
    }),

    provideConfig({
      authentication: {
        client_id: 'carlisleSales_client',
        client_secret: '',
        OAuthLibConfig: {
          redirectUri: 'https://carlisle-sales.cq7pbmgz94-carlislec1-d2-public.model-t.cc.commerce.ondemand.com',
        },
      },
    }),
  ],
})
export class SpartacusFeaturesModule {}
